import { Model } from '@vuex-orm/core'

export default class jobBoard extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'jobBoards'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      key: this.attr(null),
      description: this.attr(null),
      website: this.attr(null),
      position: this.attr(null),
      logo_url: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/JobBoard.js